// @vue/component
export const OpenlinesLoader = {
	data()
	{
		return {};
	},
	template: `
		<div class="bx-im-content-openlines__loader">
			<div class="bx-im-content-openlines__loader_spinner"></div>
		</div>
	`,
};
